import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/design-system/colors")({
  component: () => <Navigate to="/admin/design-system/colors" />,
});
